import React from "react";
import { useTranslation } from 'react-i18next';
import PropTypes from "prop-types";

import { TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';

// Forcing change for DevOps

export default function SmartTableHead(props) {
    const { classes, columns, order, orderBy, onRequestSort, collapsible } = props;
    const { t } = useTranslation();

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {/*<TableCell padding="checkbox">*/}
                {/*    <Checkbox*/}
                {/*        indeterminate={numSelected > 0 && numSelected < rowCount}*/}
                {/*        checked={rowCount > 0 && numSelected === rowCount}*/}
                {/*        onChange={onSelectAllClick}*/}
                {/*        inputProps={{ 'aria-label': 'select all desserts' }}*/}
                {/*    />*/}
                {/*</TableCell>*/}
                {collapsible &&
                    <TableCell
                        key={columns.length * 2}
                        padding="normal"
                        sortDirection={false}
                    >
                    </TableCell>
                }
                {columns.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.alignment === 'left' ? 'left' : 'right'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        style={{minWidth: headCell?.minWidth !== undefined ? headCell.minWidth : ''}}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {t(headCell.label)}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

SmartTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    columns: PropTypes.array.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};
